<template>
  <div class="sele-flow">
    <new-table ref="table" :data="flowrData" :columns="columns" :pages="pages"></new-table>
  </div>
</template>
<script>
import NewTable from "@/components/new-table.vue";
import ConnectorApis from "@/apis/connector";
export default {
  name: "sele-flow",
  props: {},
  data() {
    return {
      flowrData: [],
      columns: [
        { label: "名称", prop: "flowName" },
        { label: "描述", prop: "flowComment" },
        { label: "类型", width: "150", prop: "actionType" },
        { label: "状态", width: "150", prop: "publishStatus" },
      ],
      pages: {
        props: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.pageChange(p);
          },
        },
      },
      flowId: this.$route.query.id,
    };
  },
  created() {
    this.getFlowListData();
  },
  methods: {
    async getFlowListData() {
      const res = await ConnectorApis.getFlowList({
        pageIndex: this.pages.props["current-page"],
        pageSize: this.pages.props["current-change"],
      });
      console.log(res);
    },
  },
  components: { NewTable },
};
</script>
<style scoped lang="scss">
.sele-flow {
  display: flex;
  flex: 1;
  height: 100%;
}
</style>
